module.exports = __webpack_public_path__ + "static/media/profile_icon.2f7a09b2.png";